function createPredicate(filterString) {
    try {
        const filterObj = JSON.parse(filterString);
        return function (obj) {
            if ((filterObj === null || filterObj === void 0 ? void 0 : filterObj.must) && !filterObj.must.every((condition) => evaluateCondition(condition, obj))) {
                return false;
            }
            if ((filterObj === null || filterObj === void 0 ? void 0 : filterObj.must_not) && filterObj.must_not.some((condition) => evaluateCondition(condition, obj))) {
                return false;
            }
            if ((filterObj === null || filterObj === void 0 ? void 0 : filterObj.should) && !filterObj.should.some((condition) => evaluateCondition(condition, obj))) {
                return false;
            }
            return true;
        };
    }
    catch (error) {
        console.error('Error parsing filter string:', error);
        return () => false;
    }
}
function evaluateCondition(condition, obj) {
    if (condition.term) {
        for (const key in condition.term) {
            if (obj[key] !== condition.term[key])
                return false;
        }
    }
    if (condition.terms) {
        for (const key in condition.terms) {
            if (!condition.terms[key].includes(obj[key]))
                return false;
        }
    }
    return true;
}

export { createPredicate };
//# sourceMappingURL=condition.js.map
